import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'ark-lib-thank-you-boost-modal',
  templateUrl: './thank-you-boost-modal.component.html',
  styleUrls: ['./thank-you-boost-modal.component.css'],
})
export class ThankYouBoostModalComponent implements OnInit{

  constructor(private modalCtrl: ModalController) {}

  ngOnInit() {
    setTimeout(() => {
      this.dismiss();
    }, 3000);
  }
 
   dismiss() {
     this.modalCtrl.dismiss();
   }
}
